import axios from 'axios';
import { UserManager, WebStorageStateStore } from 'oidc-client';

const $axios = axios.create({
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Create UserManager instance for token refresh
const createUserManager = () =>
  new UserManager({
    userStore: new WebStorageStateStore(),
    authority: process.env.OIDC_AUTHORITY,
    client_id: process.env.OIDC_CLIENT_ID,
    redirect_uri: process.env.OIDC_REDIRECT_URL,
    response_type: process.env.OIDC_RESPONSE_TYPE,
    scope: process.env.OIDC_SCOPE,
    post_logout_redirect_uri: process.env.OIDC_LOGOUT_REDIRECT_URL,
    silent_redirect_uri:
      process.env.OIDC_SILENT_REDIRECT_URL ||
      `${window.location.origin}/static/silent-renew.html`,
    automaticSilentRenew: false, // We'll handle this manually
    loadUserInfo: true,
  });

// Helper function to check if token is expired or about to expire (within 60 seconds)
const isTokenExpired = (user) => {
  if (!user || !user.expires_at) {
    return true;
  }
  // Check if token expires within the next 60 seconds
  const currentTime = Math.floor(Date.now() / 1000);
  return user.expires_at - currentTime < 60;
};

// Helper function to attempt silent token renewal
const attemptSilentRefresh = async (mgr) => {
  try {
    console.log('Attempting silent token renewal...');
    const user = await mgr.signinSilent();
    if (user && !user.expired) {
      console.log('Silent token renewal successful');
      return user;
    }
    console.warn('Silent renewal returned expired user');
    return null;
  } catch (error) {
    console.error('Silent token renewal failed:', error);
    return null;
  }
};

export default $axios;
export { createUserManager, isTokenExpired, attemptSilentRefresh };



// WEBPACK FOOTER //
// ./src/helpers/axios-instance.js